import { render } from "./RepPatSummary3PatTestROList.vue?vue&type=template&id=348cbb14"
import script from "./RepPatSummary3PatTestROList.vue?vue&type=script&lang=js"
export * from "./RepPatSummary3PatTestROList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__